import { UseStore } from '@eastcoal/common/types/zustand'
import { useContextStore } from '@eastcoal/common/utils/zustand'

import { ContractDesignerEditorStoreContext } from '../contexts/StoreContext'
import { ContractDesignerEditorStore } from '../store/interface'

export const useContractDesignerEditorStore: UseStore<
  ContractDesignerEditorStore
> = selector => {
  return useContextStore(ContractDesignerEditorStoreContext, selector)
}
